/* global */

class SsrWrapper {
    install (Vue, options) {
        Vue.prototype.$isSsr = options.enabled
    }
}

export default new SsrWrapper()
